import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React from "react";
import { api } from "../../../../api/api";
import TextField from "@mui/material/TextField";
import { useSnackbar } from "notistack";

export function LockersInfoSaver(props) {

  const { enqueueSnackbar } = useSnackbar();
  const [lockersInfo, setLockersInfo] = React.useState("");


  const handleOnLockersSave = () => {
    api.secretSanta.addLockers(JSON.parse(lockersInfo))
      .then(() => {
        snackBarAddMessage(`Lockers info saved`, 'success')
      })
      .catch((error) => {
        props.onFetchFailed(error);
      })
  };

  const snackBarAddMessage = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };


  return <Paper sx={{
    mt: { xs: 2, md: 2 },
    mb: { xs: 2, md: 2 },
    p: 2,
  }}>
    <Typography variant="h6" gutterBottom>
      Lockers info
    </Typography>
    <TextField
      variant="outlined"
      margin="normal"
      id="lockersInfo"
      name="lockersInfo"
      fullWidth
      multiline
      rows={10}
      value={lockersInfo}
      onChange={(event) => {
        setLockersInfo(event.target.value)
      }}
    />
    <Button
      variant="contained"
      color="primary"
      onClick={handleOnLockersSave}
      sx={{ mt: 3, ml: 1 }}
    >
      Save
    </Button>

  </Paper>;
}
